import { Outlet } from 'react-router-dom';

import { BottomNav } from './bottom-nav';

/**
 * Shell for the three primary tabs.
 *
 * The bottom bar is fixed, so the scroll container reserves its height plus the
 * safe-area inset; without that padding the last row of every list would sit
 * permanently under the navigation.
 */
export function TabLayout() {
  return (
    <div className="min-h-dvh">
      <div className="app-column pb-[calc(3.5rem+env(safe-area-inset-bottom,0px))]">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

/** Shell for pushed screens: full height, no tab bar, no width cap surprises. */
export function StackLayout() {
  return (
    <div className="min-h-dvh">
      <div className="app-column">
        <Outlet />
      </div>
    </div>
  );
}
